<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const router = useRouter();

const nextLogin = () => {
  router.push("/signin");
};

const store = useStore();

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  document.body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  document.body.classList.add("bg-gray-100");
});
</script>

<template>
  <div class="verify-completed">
    <div class="container">
      <div class="row justify-content-center align-items-center min-vh-100">
        <div class="col-md-5">
          <div class="card shadow border-0">
            <div class="card-body p-4">
              <div class="mb-4">
                <!-- Icons from the image -->
                <div class="d-flex mb-4">
                  <div class="position-relative">
                    <img
                      src="../../../public/assets/icons/ic_verified_mail.svg"
                      width="120"
                      height="105"
                    />
                  </div>
                </div>

                <h3 class="fw-bold custom-heading">Email Already Verified</h3>
                <p class="text-muted mt-3 paragraph-text-style">
                  Your email has already been verified. You can proceed to log
                  in to your account. <br />
                </p>
              </div>

              <div class="mt-4">
                <p class="text-muted">
                  <argon-button
                    @click="nextLogin"
                    class="btn btn-success btn-lg w-50 login-gradient"
                    >Go to Login</argon-button
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.verify-completed {
  background-color: #f0f8f0;
  background-image: url("/public/bg-login.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
}

.verification-page {
  background-color: #f0f8f0;
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23b8e0b8' fill-opacity='0.2' fill-rule='evenodd'/%3E%3C/svg%3E");
  min-height: 100vh;
}

.envelope-icon {
  position: relative;
  display: inline-block;
}

.card {
  border-radius: 12px;
}

a:hover {
  color: #198754 !important;
}

.text-primary {
  color: #198754 !important;
}

.paragraph-text-style {
  font-family: "IBM Plex Sans Devanagari", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.75%;
  vertical-align: middle;
}

.custom-heading {
  font-family: "IBM Plex Sans Devanagari", sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0;
  vertical-align: middle;
}

.login-gradient {
  background: linear-gradient(180deg, #43bb75 0%, #1c9762 100%);
}
</style>
